"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnauthenticatedRoute = void 0;
var react_1 = __importDefault(require("react"));
var react_router_1 = require("react-router");
/** If our route matches, then either show `component` (if unauthed) or redirect to /. */
function UnauthenticatedRoute(_a) {
    var Component = _a.component, authProps = _a.authProps, rest = __rest(_a, ["component", "authProps"]);
    if (!Component)
        return null;
    return (react_1.default.createElement(react_router_1.Route, __assign({}, rest, { render: function (props) { return (!authProps.isAuthenticated ? react_1.default.createElement(Component, __assign({}, props, authProps)) : react_1.default.createElement(react_router_1.Redirect, { to: "/" })); } })));
}
exports.UnauthenticatedRoute = UnauthenticatedRoute;
//# sourceMappingURL=UnauthenticatedRoute.js.map